import { Injectable } from '@angular/core';

// Define data structures (Interfaces)
export interface ServiceItem {
  icon: string;
  title: string;
  description: string;
}

export interface AccordionItem {
  title: string;
  steps: string[];
}

@Injectable({
  providedIn: 'root',
})
export class DataService {

  // --- Data: Services ---
  public getServices(): ServiceItem[] {
    return [
      {
        icon: 'cloud',
        title: 'ICT Project Review Criteria',
        description: 'Projects will be reviewed using established review criteria, each criterion have a list of items to be reviewed.'
      },
      {
        icon: 'checklist',
        title: 'ICT Project Review Checklist',
        description: 'Detailed list of items derived from ICT project review criteria to be adhered by Public Institution.'
      },
      {
        icon: 'book',
        title: 'ICT Standards & Guidelines',
        description: 'Technical guidance for Public Institutions to comply when engage on Government ICT initiatives.'
      },
      {
        icon: 'supervised_user_circle',
        title: 'Expert Support',
        description: '24/7 dedicated technical support desk and on-site assistance for hardware and software issues.'
      }
    ];
  }

  // --- Data: How Do I Accordion ---
  public getAccordionData(): AccordionItem[] {
    return [
      {
        title: "Register ICT Project",
        steps: [
          "To register ICT project onto the GISP, you must be registered first before you can login.",
          "On the left side, under the ICT Menu, select the 'Register ICT Project'.",
          "Fill all required fields per the Concept Note Form.",
          "Click Submit button upon completion.",
          "Upon successful submission of the registered ICT project, you will receive a confirmation that you have successful submitted a project for review."
        ]
      },
      {
        title: "Get Status of Submitted ICT Project",
        steps: [
          "To get status of the submitted ICT project onto the GISP, you must login onto GISP by clicking login button on the top of the page.",
          "Enter your credentials (username and password).",
          "On the left side, under the ICT Project Menu, select 'Project List'.",
          "The Project list will populate, then search or select a project to view status.",
        ]
      },
      {
        title: "Get Status of Requested Service",
        steps: [
          "To get status of the requested service onto the GISP, you must login onto GISP by clicking login button on the top of the page.",
          "Enter your credentials (username and password).",
          "On the left side, under the Services Menu, select 'Requested Services'.",
          "The Requested Services will populate, then search or select service requested to view status.",
        ]
      },
      {
        title: "Report a security incident",
        steps: [
          "You must be registered first before you can login.",
          "On the left side, under the ICT Menu, select the 'Security Incident'.",
          "Fill all required fields as per Form.",
          "Click Submit button upon completion.",
          "Upon successful submission of the Security Incident, you will receive a confirmation that you have successfully submitted a security Incident."
        ]
      }
    ];
  }
}
